import { Breadcrumbs } from "../../../AbstractElements";
import { Container, Row } from "reactstrap";
import { FormControls, ValidationForms } from "../../../Constant";
import TooltipFormValidation from "./TooltipFormValidation";
import BrowserDefaults from "./BrowserDefaults";
import ValidationForm from "./ValidationForm";

const FormValidationContainer = () => {
  return (
    <>
    <Breadcrumbs pageTitle={ValidationForms} parent={FormControls} title={ValidationForms} />
    <Container fluid>
        <Row>
          <TooltipFormValidation />
          <BrowserDefaults/>
          <ValidationForm/>
        </Row>
    </Container>
    </>
  )
};

export default FormValidationContainer;
